import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTreatment } from '../context/TreatmentContext';
import { useAuth } from '../context/AuthContext';
import apiService from '../services/api';
import { Users } from 'lucide-react';

const TreatmentSubHeader = () => {
  const { currentPatient, setCurrentPatient, clearCurrentPatient } = useTreatment();
  const { isAuthenticated, user } = useAuth();
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated() || user?.role === 'Student') return;
    const fetchPatients = async () => {
      setLoading(true);
      try {
        const data = await apiService.getPatients();
        setPatients(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Failed to fetch patients for selector:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPatients();
  }, [isAuthenticated, currentPatient?.id, user?.role]); // Re-fetch on select or change

  const handlePatientChange = (e) => {
    const val = e.target.value;
    if (val === 'new') {
      navigate('/treatment/patients');
    } else if (val === 'none') {
      clearCurrentPatient();
    } else {
      const selected = patients.find((p) => String(p.id) === String(val));
      if (selected) {
        setCurrentPatient(selected);
      }
    }
  };

  if (!isAuthenticated() || location.pathname === '/treatment' || user?.role === 'Student') return null;

  // Initials for avatar
  const getInitials = (name) => {
    if (!name) return '?';
    return name.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase();
  };

  return (
    <div className="treatment-sub-header no-print">
      <div className="container treatment-sub-header-container">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div className="treatment-patient-picker-wrap">
            <div className="treatment-patient-avatar">
              {currentPatient ? getInitials(currentPatient.name) : <Users size={16} />}
            </div>
            <select
              className="treatment-patient-select"
              value={currentPatient?.id || 'none'}
              onChange={handlePatientChange}
              disabled={loading}
            >
              <option value="none">-- Select Patient Profile --</option>
              {patients.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name} ({p.age}y, {p.gender})
                </option>
              ))}
              <option value="new">+ Add New Patient Profile</option>
            </select>
          </div>
          {currentPatient && currentPatient.prakriti && (
            <span className="prakriti-question-category" style={{ margin: 0 }}>
              Prakriti: {currentPatient.prakriti}
            </span>
          )}
        </div>

        {location.pathname !== '/treatment' && (
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <Link to="/treatment" className="btn btn-outline btn-small">
              ← Back to Patient Workspace
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default TreatmentSubHeader;
